import {AutoEncoder, field, StringDecoder} from '@simonbackx/simple-encoding'

export class DiscountInfo extends AutoEncoder {
    @field({decoder: StringDecoder})
    code: string

    @field({decoder: StringDecoder, nullable: true})
    verification: string | null
}
